import React from "react";
import HumanBanner from "./HumanBanner";
import HomeClientLogo from "../../home/HomeClientLogo";
import HumanPotential from "./HumanPotential";
import HomeCounter from "../../home/HomeCounter"
import HumanDiscuss from "./HumanDiscuss";
import HumanBenefits from "./HumanBenefits";
import HumanGoals from "./HumanGoals";
import HumanCompany from "./HumanCompany";
import HumanSmart from "./HumanSmart";

const bannerData = {
  head: "Empowering HR Teams with Smarter Document Management",
  desc: "Dox and Box enables HR teams to digitize employee records, streamline workflows, and ensure compliance through a secure, centralized platform. Empowering HR teams, from onboarding and contract management to leave tracking and audits, our solutions bring complete visibility, control, and efficiency to your HR operations.",
  slug: "",
  btn: "Contact Us",
  img: "/assets/images/human-resources-banner-img1.webp"
}

const humanPotentialData = {
  head: "Transforming HR Operations for Better Outcomes ",
  boxes: [
    {
      title: "Common Challenges in HR Operations",
      list: [
        {
          label: "Fragmented Information Slows Productivity",
          desc: "Employee records and HR documents are often scattered across systems, making access difficult and delaying decision-making."
        },
        {
          label: "Manual Processes Limit Efficiency",
          desc: "Repetitive tasks such as onboarding, document handling, approvals are time-consuming and prone to errors."
        },
        {
          label: "Compliance and Audit Risks",
          desc: " Inconsistent access controls and manual record-keeping increase the risk of non-compliance and audit challenges."
        },
        {
          label: "Administrative Overload",
          desc: " HR teams spend excessive time on operational tasks, leaving limited bandwidth for strategic initiatives and employee engagement."
        },
      ]
    },
    {
      title: "Work Smarter with Dox and Box",
      list: [
        {
          label: "Centralized & Secure Information Access",
          desc: "Bring all employee records into a unified system with controlled access for HR teams, managers, stakeholders."
        },
        {
          label: "Automated HR Workflows",
          desc: " Streamline processes like onboarding, approvals, document management with automated, error-free workflows."
        },
        {
          label: "Built-In Compliance & Audit Readiness",
          desc: " Ensure secure handling of HR data with role-based access, audit trails, compliance-ready systems."
        },
        {
          label: "Focus on Strategic HR Initiatives",
          desc: " Reduce administrative burden through automation, enabling HR teams to focus on employee experience, retention, organizational growth."
        },
      ]
    }
  ]
}

const countData = [
  {
    number: "24",
    suffix: "K+",
    desc: "<b>Businesses Served</b>: Trusted by organizations across diverse industries"
  },
  {
    number: "99",
    suffix: "%",
    desc: "<b>Retrieval Accuracy</b>: Ensure fast, precise, reliable access to documents"
  },
  {
    number: "14",
    suffix: "K+",
    desc: "<b>Documents Digitized</b>: Converted into structured, indexed, fully searchable digital formats"
  },
  {
    number: "40",
    suffix: "%",
    desc: "<b>Efficiency Gains</b>: Reduce manual effort, streamline workflows, & operational productivity"
  },
]

const discussData = {
  head: "Build Smarter HR Workflows Today",
  desc: "Speak with our experts at ",
  number: "+91 9580374374",
  btn: "Contact Us",
  slug: "/contact",
  newClass: ""
}

const smartData = {
  head: "Smart HR Workflows for a Seamless Employee Experience",
  desc: "Simplify and streamline every stage of the employee lifecycle, from hiring to exit, through secure, automated, fully digital processes.",
  boxes: [
    {
      label: "DIGITAL EMPLOYEE RECORDS",
      innerHead: "Centralized, secure management of personnel files",
      innerDesc: "Manage all employee records, including contracts, payslips, medical documents, training certificates, performance reviews, in one secure, digital repository. Dox and Box ensures automatic organization, controlled access, real-time visibility for HR teams and leadership, while enabling employees to securely access their own records when needed.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/home-smart-image1.webp"
    },
    {
      label: "PAYROLL DISTRIBUTION",
      innerHead: "Secure and efficient payroll distribution",
      innerDesc: "Digitize and streamline payroll communication by securely storing and sharing payslips and reports through a centralized system. Reduce manual effort, eliminate paper-based processes, ensure confidentiality and compliance across your organization.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/home-smart-image2.webp"
    },
    {
      label: "ONBOARDING & OFFBOARDING",
      innerHead: "Seamless employee transitions",
      innerDesc: "Enhance the onboarding experience with automated workflows that provide new hires with timely access to essential documents and information. Manage offboarding efficiently by tracking tasks such as document handovers, asset recovery, access control, ensuring a smooth and compliant transition.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/home-smart-image3.webp"
    },
    {
      label: "Recruitment Management",
      innerHead: "Structured hiring for faster decisions",
      innerDesc: "Optimize recruitment workflows with organized document handling and streamlined processes. Manage candidate records securely, coordinate hiring stages efficiently, ensure compliance with data retention and privacy requirements.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/home-smart-image4.webp"
    },
    {
      label: "Leave & Request Management",
      innerHead: "Simplified employee requests and approvals",
      innerDesc: "Enable employees to submit leave requests and updates digitally, while HR teams and managers can review and approve them quickly through automated workflows. Improve transparency, reduce delays, enhance internal communication.",
      btn: "Contact Us",
      slug: "/contact",
      image: "/assets/images/home-smart-image5.webp"
    },

  ],
}

const benifitData = {
  head: "Driving Digital Transformation Across Your HR Ecosystem ",
  boxClass: "",
  slides: [
    {
      label: "Recruitment",
      desc: "Organize candidate data and accelerate hiring with structured, efficient processes.",
      img: '/assets/images/human-benifits-cards-icon-1.webp'
    },
    {
      label: "Team Management",
      desc: "Access critical documents quickly to support faster decisions and team coordination.",
      img: '/assets/images/human-benifits-cards-icon-2.webp'
    },
    {
      label: "HR Management",
      desc: "Centralize employee records, streamline workflows, ensure compliance with ease.",
      img: '/assets/images/human-benifits-cards-icon-3.webp'
    },
    {
      label: "Employees",
      desc: "Empower employees with secure, anytime access to their records and requests.",
      img: '/assets/images/human-benifits-cards-icon-2.webp'
    },
  ]
}

const goalData = {
  head: "Transforming HR with Smarter Document Management",
  boxes: [
    {
      img: "/assets/images/human-goal-icon1.webp",
      title: "Intelligent Data Management",
      desc: "Capture, organize, manage HR data efficiently, reducing manual effort and improving accuracy.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon2.webp",
      title: "Workflow Automation",
      desc: "Automate repetitive HR processes, from onboarding to approvals, saving time and increasing productivity.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon3.webp",
      title: "Document Hub",
      desc: "Store and access employee data in a secure, centralized system with easy search and retrieval capabilities.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon4.webp",
      title: "Seamless Collaboration",
      desc: "Enable real-time coordination between HR teams, managers, employees across locations.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon5.webp",
      title: "Actionable Insights",
      desc: "Leverage structured data to gain better visibility into HR operations and support informed decision-making.",
      slug: "",
    },
    {
      img: "/assets/images/human-goal-icon6.webp",
      title: "Security & Compliance",
      desc: "Ensure data protection with role-based access, audit trails, compliance-ready document management systems.",
      slug: "",
    },
  ]
}

export default function HumanResources() {
  return (
    <>
      <HumanBanner data={bannerData} />
      <HomeClientLogo />
      <HumanPotential data={humanPotentialData} />
      <HomeCounter countData={countData} />
      <HumanDiscuss data={discussData} />
      <HumanBenefits data={benifitData} />
      <HumanSmart smartData={smartData} />
      <HumanGoals data={goalData} />
      <HumanCompany />
    </>
  )
}